import React from 'react';
import { Link } from 'react-router-dom';
import { 
  BookOpen, 
  Gift, 
  Heart, 
  Sparkles, 
  ArrowRight,
  Download,
  Users,
  Mail,
  User
} from 'lucide-react';

const JANELLE_PHOTO = 'https://customer-assets.emergentagent.com/job_98f4c0a7-37e3-4eee-b45d-3c901b2920ec/artifacts/e2kpke7l_IMG_5756.jpeg';
const LOGO_URL = 'https://customer-assets.emergentagent.com/job_98f4c0a7-37e3-4eee-b45d-3c901b2920ec/artifacts/cpmel363_Purpose%20reclaimed%20coaching.png';

export const LinkInBio = () => {
  return (
    <div 
      data-testid="link-in-bio" 
      className="min-h-screen bg-gradient-to-b from-sage-light/30 via-cream to-sky-light/30 py-10 px-6"
    >
      <div className="max-w-sm mx-auto">
        {/* Profile Section */}
        <div className="text-center mb-8 animate-fade-in">
          <img 
            src={LOGO_URL} 
            alt="Purpose Reclaimed Coaching" 
            className="w-24 h-24 mx-auto mb-4 rounded-full object-cover shadow-lg"
          />
          <h1 className="font-heading text-2xl text-charcoal mb-1">Purpose Reclaimed Coaching</h1>
          <p className="text-charcoal-light text-sm">Janelle McGowan-Charles</p>
          <p className="text-xs text-charcoal-light/70 mt-2">
            Faith-led coaching for women healing from trauma & abuse
          </p>
        </div>

        {/* Main Links */}
        <div className="space-y-4">
          {/* Coaching - Primary CTA */}
          <Link
            to="/coaching"
            data-testid="bio-coaching-link"
            className="group block w-full p-4 bg-gradient-to-r from-sage to-sage/80 text-white rounded-2xl shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5"
          >
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-xl bg-white/20 flex items-center justify-center">
                <Heart className="w-6 h-6" />
              </div>
              <div className="flex-1 text-left">
                <p className="font-medium">1-to-1 Coaching</p>
                <p className="text-xs opacity-80">Free 1-hour clarity session</p>
              </div>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </div>
          </Link>

          {/* Ebook Packages */}
          <Link
            to="/purchase"
            data-testid="bio-purchase-link"
            className="group block w-full p-4 bg-white text-charcoal rounded-2xl shadow-md hover:shadow-lg transition-all hover:-translate-y-0.5 border border-gold/20"
          >
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-xl overflow-hidden flex-shrink-0">
                <img src="https://static.prod-images.emergentagent.com/jobs/98f4c0a7-37e3-4eee-b45d-3c901b2920ec/images/0470b11727d32ba005664c3bc8b17f0ec5bd3d699a6a10c5afd06c63414fb5d3.png" alt="Breakthrough" className="w-full h-full object-cover" />
              </div>
              <div className="flex-1 text-left">
                <p className="font-medium">Breakthrough Ebook Packages</p>
                <p className="text-xs text-charcoal-light">Ebook, worksheets, prayer guides & more</p>
                <p className="text-xs text-gold font-medium mt-1">From £17</p>
              </div>
              <ArrowRight className="w-5 h-5 text-gold group-hover:translate-x-1 transition-transform" />
            </div>
          </Link>

          {/* FREE Resources */}
          <Link
            to="/free"
            data-testid="bio-free-link"
            className="group block w-full p-4 bg-gradient-to-r from-gold to-gold/80 text-white rounded-2xl shadow-md hover:shadow-lg transition-all hover:-translate-y-0.5"
          >
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-xl bg-white/20 flex items-center justify-center">
                <Gift className="w-6 h-6" />
              </div>
              <div className="flex-1 text-left">
                <div className="flex items-center gap-2">
                  <span className="text-xs font-bold uppercase tracking-wider opacity-90">FREE</span>
                  <Sparkles className="w-3 h-3" />
                </div>
                <p className="font-medium">2 Free Healing Resources</p>
                <p className="text-xs opacity-80">Chapter 1 + "5 Lies Survivors Believe"</p>
              </div>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </div>
          </Link>

          {/* Workshops */}
          <Link
            to="/workshops"
            data-testid="bio-workshops-link"
            className="group block w-full p-4 bg-white text-charcoal rounded-2xl shadow-md hover:shadow-lg transition-all hover:-translate-y-0.5 border border-stone-100"
          >
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-xl bg-sky/20 flex items-center justify-center">
                <Users className="w-6 h-6 text-sky-dark" />
              </div>
              <div className="flex-1 text-left">
                <p className="font-medium">Healing Workshops</p>
                <p className="text-xs text-charcoal-light">Coming soon — join the waitlist</p>
              </div>
              <ArrowRight className="w-5 h-5 text-charcoal-light group-hover:translate-x-1 transition-transform" />
            </div>
          </Link>

          {/* About */}
          <Link
            to="/about"
            data-testid="bio-about-link"
            className="group block w-full p-4 bg-white text-charcoal rounded-2xl shadow-md hover:shadow-lg transition-all hover:-translate-y-0.5 border border-stone-100"
          >
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-xl bg-sage/10 flex items-center justify-center">
                <User className="w-6 h-6 text-sage" />
              </div>
              <div className="flex-1 text-left">
                <p className="font-medium">About Janelle</p>
                <p className="text-xs text-charcoal-light">My story & mission</p>
              </div>
              <ArrowRight className="w-5 h-5 text-charcoal-light group-hover:translate-x-1 transition-transform" />
            </div>
          </Link>

          {/* Contact */}
          <Link
            to="/contact"
            data-testid="bio-contact-link"
            className="group block w-full p-4 bg-white text-charcoal rounded-2xl shadow-md hover:shadow-lg transition-all hover:-translate-y-0.5 border border-stone-100"
          >
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-xl bg-gold/10 flex items-center justify-center">
                <Mail className="w-6 h-6 text-gold" />
              </div>
              <div className="flex-1 text-left">
                <p className="font-medium">Contact Me</p>
                <p className="text-xs text-charcoal-light">Book a free session or ask a question</p>
              </div>
              <ArrowRight className="w-5 h-5 text-charcoal-light group-hover:translate-x-1 transition-transform" />
            </div>
          </Link>

          {/* Downloads - For Purchasers */}
          <Link
            to="/downloads"
            data-testid="bio-downloads-link"
            className="group block w-full p-4 bg-gradient-to-r from-sage/10 to-sky/10 text-charcoal rounded-2xl shadow-md hover:shadow-lg transition-all hover:-translate-y-0.5 border border-sage/20"
          >
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-xl bg-sage/20 flex items-center justify-center">
                <Download className="w-6 h-6 text-sage" />
              </div>
              <div className="flex-1 text-left">
                <div className="flex items-center gap-2">
                  <span className="text-xs font-medium text-sage uppercase">Purchased?</span>
                </div>
                <p className="font-medium">Access Your Downloads</p>
                <p className="text-xs text-charcoal-light">Ebook, worksheets, prayer guide & more</p>
              </div>
              <ArrowRight className="w-5 h-5 text-sage group-hover:translate-x-1 transition-transform" />
            </div>
          </Link>
        </div>

        {/* Social Media Links */}
        <div className="flex justify-center gap-4 mt-6">
          <a href="https://www.instagram.com/jan_elle_9494" target="_blank" rel="noopener noreferrer"
            data-testid="bio-instagram" className="w-11 h-11 rounded-full bg-white shadow-md flex items-center justify-center hover:shadow-lg hover:-translate-y-0.5 transition-all">
            <svg className="w-5 h-5 text-sage" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
          </a>
          <a href="https://www.tiktok.com/@jan62249" target="_blank" rel="noopener noreferrer"
            data-testid="bio-tiktok" className="w-11 h-11 rounded-full bg-white shadow-md flex items-center justify-center hover:shadow-lg hover:-translate-y-0.5 transition-all">
            <svg className="w-5 h-5 text-sage" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 0010.86 4.48V13.2a8.16 8.16 0 005.58 2.2V12a4.85 4.85 0 01-3.77-1.54V6.69h3.77z"/></svg>
          </a>
          <a href="https://www.facebook.com/mcgowan.charles.janelle" target="_blank" rel="noopener noreferrer"
            data-testid="bio-facebook" className="w-11 h-11 rounded-full bg-white shadow-md flex items-center justify-center hover:shadow-lg hover:-translate-y-0.5 transition-all">
            <svg className="w-5 h-5 text-sage" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
          </a>
          <a href="https://www.linkedin.com/in/janelle-mcgowan-charles" target="_blank" rel="noopener noreferrer"
            data-testid="bio-linkedin" className="w-11 h-11 rounded-full bg-white shadow-md flex items-center justify-center hover:shadow-lg hover:-translate-y-0.5 transition-all">
            <svg className="w-5 h-5 text-sage" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
          </a>
          <a href="mailto:jmcgowancharles@gmail.com"
            data-testid="bio-email" className="w-11 h-11 rounded-full bg-white shadow-md flex items-center justify-center hover:shadow-lg hover:-translate-y-0.5 transition-all">
            <Mail className="w-5 h-5 text-sage" />
          </a>
        </div>

        {/* Scripture Quote */}
        <div className="mt-8 p-5 bg-white/60 backdrop-blur-sm rounded-xl text-center">
          <p className="font-heading text-lg italic text-charcoal/80">
            "He heals the brokenhearted and binds up their wounds."
          </p>
          <p className="text-xs text-gold mt-2">— Psalm 147:3</p>
        </div>

        {/* Footer */}
        <div className="mt-8 text-center">
          <p className="text-xs text-charcoal-light">
            By Janelle McGowan-Charles
          </p>
          <p className="text-xs text-charcoal-light/70">
            Purpose Reclaimed Coaching
          </p>
          <p className="text-xs text-charcoal-light/50 mt-2">
            © {new Date().getFullYear()} All rights reserved
          </p>
        </div>
      </div>
    </div>
  );
};
